









import Vue from 'vue';
import { Component } from 'vue-property-decorator';

/**
 * Page d'erreur.
 */
@Component
export default class ErrorPage extends Vue {
	goToPreviousPage() {
		window.location.href = document.referrer;
	}
}
